import { notificationsTypes } from './notifications.types';

export const markAsReaded = (notification) => ({
  type: notificationsTypes.MARK_AS_READED,
  payload: notification,
});

export const updateIsAllNotificationReaded = () => ({
  type: notificationsTypes.UPDATE_IS_ALL_NOTIFICATION_READED,
});
